import { ArrowForward, HighlightOff, Search } from '@mui/icons-material';
import { InputAdornment, TextField } from '@mui/material';
import { useState } from 'react';

type SearchInputProps = {
  readonly initInput: string;
  readonly search: (value: string) => void;
};

export const SearchInput: React.FC<SearchInputProps> = ({ search, initInput }: SearchInputProps) => {
  const [inputValue, setInputValue] = useState(initInput);

  const clearSearch = (): void => {
    setInputValue('');
    search('');
  };

  const handleSearchIconClick = (): void => {
    search(inputValue.trim());
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === 'Enter') {
      search(inputValue.trim());
    } else if (event.key === 'Escape') {
      clearSearch();
      search('');
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setInputValue(event.target.value);
  };

  return (
    <TextField
      placeholder="Suche"
      autoFocus
      value={inputValue}
      onChange={handleChange}
      slotProps={{
        input: {
          onKeyDown,
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {inputValue !== '' && <HighlightOff sx={{ cursor: 'pointer' }} onClick={clearSearch} />}
              <ArrowForward color="info" sx={{ cursor: 'pointer' }} onClick={handleSearchIconClick} />
            </InputAdornment>
          ),
        },
      }}
      sx={{ maxWidth: '90vw', width: '60em', background: 'white' }}
      variant="outlined"
    />
  );
};
